module.exports = __webpack_public_path__ + "img/diao_guan_ji-icon0.9d7dca99.png";